module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_redefine.js
// module id = 68
// module chunks = 0 1 2 3 4